/* eslint-disable import/prefer-default-export */
import { DEFAULT_SUMMARY } from '../constants/orderSummaryConstants';

export const getDefaultFormValues = ({
  customer,
  currentRetailerUser,
  maskedPhone,
  agentName,
  currency
}) => ({
  customer: {
    id: customer?.id,
    id_in_mercately: customer?.id,
    first_name: customer?.first_name ?? '',
    last_name: customer?.last_name ?? '',
    username: customer?.username ?? '',
    email: customer?.email ?? '',
    phone: maskedPhone,
    address: customer?.address ?? '',
    city: customer?.city ?? '',
    state: customer?.state ?? '',
    zip_code: customer?.zip_code ?? '',
    country_id: customer?.country_id ?? '',
    id_type: customer?.id_type ?? '',
    id_number: customer?.id_number ?? '',
    web_id: customer?.web_id ? customer.web_id : '',
    web_id_in_mercately: customer?.web_id,
    id_in_shops: customer?.id_in_shops ? customer.id_in_shops : '',
    ws_active: customer?.ws_active,
    username: customer?.username || ''
  },
  customFields: {},
  status: 'pending',
  retailer_user_id: '',
  sales_channel_id: '',
  notes: '',
  agent_id: String(customer?.assigned_agent?.id || currentRetailerUser?.id),
  agent_name: customer?.assigned_agent?.full_name || agentName,
  agent_email: customer?.assigned_agent?.email || currentRetailerUser?.email,
  address: '',
  city: '',
  state: '',
  zip_code: '',
  subtotal: 0,
  tax_amount: 0,
  total: 0,
  shipping_value: '',
  delivery_method: '',
  currency: currency || '',
  update_terms: false,
  terms_and_condition: {
    terms_conditions_content: ''
  },
  custom_answers: [],
  discount_type: '',
  discount_value: 0,
  discount_reason: '',
  total_discount: 0,
  subtotal_with_discount: 0,
  // extras
  orderAddress: '',
  shipping_cost_id: '',
  description: '',
  country_id: '',
  selectedProducts: [],
  removedSelectedProducts: [],
  customAnswers: [],
  orderSummary: DEFAULT_SUMMARY,
  filledShippingCostManually: false
});
